const queixas = [
  'Avaliação de rotina',
  'Retorno',
  'Aumento da PA',
  'Oscilação da PA',
  'Assintomático cardiovascular',
  'Nega dor precordial, dispneia, palpitações, edema, tonturas ou síncope',
  'Nega dor precordial relacionada a esforços',
  'Dor precordial relacionada com esforço físico',
  'Dor precordial em repouso, sem relação com esforço físico',
  'Dor torácica atípica',
  'Cansaço aos esforços',
  'Cansaço físico / indisposição sem dispneia',
  'Palpitações frequentes',
  'Tonturas posturais',
  'Tonturas rotatórias (labirintopatia)',
  'Edema em MMII com piora vespertina',
  'Cefaleia frequente',
  'Cefaleia na região da nuca',
  'Avaliação pré-operatória de',
  'Avaliação para realização de',
];
const habitos = [
  'Sedentário',
  'Atividade física regular',
  'Ativo no trabalho e em atividades diárias',
  'Academia  _x/semana',
  'Caminhada regular _x/semana',
  'Hidroginática _x/semana',
  'Pilates _x/semana',
  'Nega tabagismo',
  'Nega tabagismo e etilismo',
  'Nega tabagismo, etilismo e consumo de café',
  'Tabagista há ___ anos, fuma ___ cigarros por dia',
  'Ex-tabagista, parou há ___ anos (fumou por ___ anos)',
  'Etilista – ___ cervejas por dia',
  'Consumo social de bebida alcoólica',
  'Ex-etilista, parou há ___ anos',
  'Nega consumo de café',
  'Consumo de café – pouco',
  'Consumo de café – bastante',
  'Dieta bem controlada',
  'Dieta não controlada',
  'Dieta pouco controlada, sem grandes abusos',
  'Acompanhamento com nutricionista – dieta bem controlada',
];
const antecedentes = [
  'Nega HAS e AVE',
  'Nega DM e dislipidemia',
  'Nega eventos como IAM ou AVC',
  'HAS há ___ anos',
  'DM há ___ anos',
  'Dislipidemia há ___ anos',
  'Epidemiologia para Chagas – negativo',
  'Epidemiologia para Chagas – positivo',
  'Ansioso',
  'Muito ansioso',
  'Síndrome do pânico',
  'Depressão há ___ anos',
  'Nega cirurgias prévias',
  'Nega alergia',
  'Angioplastia com stent convencional em ___',
  'Angioplastia com stent farmacológico em ___',
  'Revascularização do miocárdio em ___',
];

const fisico = [
  'Normal',
  'PA ___ mmHg e FC ___ bpm - Peso ___ kg e altura ___ cm',
  'RCR em 2T, sem sopro',
  'RCR em 2T, com sopro sistólico +/6+ em foco ___',
  'RCR em 2T, com sopro diastólico +/4+ em foco ___',
  'RCI em FA e sem sopros',
  'RCI em FA com sopro sistólico em foco ___',
  'MV+ sem ruídos adventícios',
  'MV+ com estertores crepitantes em bases',
  'MV+ com estertores crepitantes até o terço médio',
  'MV+ com diminuição global',
  'Abdome flácido e indolor, ausência de VMG, com RHA presentes',
  'Abdome flácido e indolor, fígado palpável a 3 cm do rebordo costal, indolor, RHA presentes',
  'Ausência de edema em MMII',
  'Presença de edema em MMII 4+/4+',
  'Pulsos presentes e simétricos',
  'Pulsos diminuídos em MMII',
  'Ausência de estase jugular',
  'Presença de estase jugular 4+/4+',
  'Carótidas sem sopro',
  'Carótida com sopro sistólico 4+/4+',
];

const hipotese = [
  'Avaliação de rotina',
  'Avaliação pré-operatória de',
  'Eutrófico (cardiovascular)',
  'Dor precordial',
  'Dor torácica',
  'Doença Arterial Coronariana Crônica Estável',
  'IAM prévio',
  'Angioplastia com stent convencional em ___',
  'Angioplastia com stent farmacológico em ___',
  'Revascularização do miocárdio em ___',
  'HAS',
  'PA oscilando (HAS)',
  'Intolerância à glicose',
  'Diabetes Mellitus tipo II',
  'Diabetes Mellitus tipo I',
  'Dislipidemia',
  'Síndrome metabólica',
  'Obesidade',
  'Insuficiência Cardíaca Congestiva',
  'Insuficiência Cardíaca Sistólica',
  'Insuficiência Cardíaca Diastólica',
  'Fibrilação Atrial de início recente',
  'Fibrilação Atrial Permanente',
  'Fibrilação Atrial Persistente',
  'Fibrilação Atrial Paroxística',
  'Fibrilação Atrial revertida em ___',
  'Hipertireoidismo',
  'Hipotireoidismo',
  'DPOC',
  'Ansiedade',
  'Depressão',
  'Síndrome do pânico',
];

const conduta = [
  'Retornar para nova avaliação em ___',
  'Mudanças de hábitos de vida: exercício, dieta e redução de peso',
  'Melhorar dieta, aumentar exercício e reduzir peso',
  'Manter controle com dieta e exercício',
  'Controle da PA',
  'Exames laboratoriais',
  'Ecodopplercardiograma',
  'Ecocardiograma com estresse fisiológico',
  'Ecocardiograma com estresse farmacológico',
  'Ecocardiograma transesofágico',
  'Doppler de carótidas',
  'Cintilografia do miocárdio',
  'Teste ergométrico',
  'Holter',
  'MAPA',
  'Looper (monitor de eventos)',
  'Angiotomografia de coronárias',
  'TC para escore de cálcio',
  'CATE (cateterismo cardíaco)',
  'Estudo eletrofisiológico e ablação',
  'Ultrassom de abdome',
  'Cirurgia cardíaca de revascularização',
  'Cirurgia cardíaca valvar',
  'Angioplastia com stent em ___',
];

export { antecedentes, conduta, fisico, habitos, hipotese, queixas };
